import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page68() {
  useEffect(() => {
    document.title = "Маяк — Страница 67"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page66" />
        <ForwardLink href="/page68" />
      </div>

      <p style={{ textAlign: "right" }}>67.</p>
      <p>Чтобы добраться куда-либо, нужно слишком много времени.</p>
      <p>Назад к ВЫРЕЗАННОЙ РУСАЛКЕ...</p>
      <p>Шлепок. Шлепок. Шлепок. Шлепок. Шлепок.</p>
      <p>У него устала рука.</p>
      <p>Шлепок. Шлепок. Шлепок. Шлепок. Шлепок.</p>
      <p>
        Он чувствует, как что-то приближается, поднимается внутри него, он кладет<br/>
        другую руку на шаткую стену... он кончит... скоро...
      </p>
      <p>У него не выходит.</p>
      <p>
        КАРТИНКА: ШИРОКИЙ ПЛАН: МОЛОДОЙ сверху на РУСАЛКЕ (настоящей,<br/>
        а не вырезанной), его штаны наполовину спущены, ТРАХАЕТ ЕЕ, ПОКА<br/>
        НА НИХ ПЛЕЩЕТСЯ МОРЕ.
      </p>
      <p>КАРТИНКА: ЩУПАЛЬЦА, РЫБЬИ ХВОСТЫ, ВОДОРОСЛИ ПЕРЕПЛЕТАЮТСЯ, ИЗВИВАЮТСЯ.</p>
      <p>
        КАРТИНКА: РУКИ РУСАЛКИ ХВАТАЮТ МОЛОДОГО ЗА ГОРЛО, УТАСКИВАЮТ ЕГО<br/>
        В МОРЕ И СЛИЗЬ.
      </p>
      <p>
        КАРТИНКА: ЛИЦО МУЖЧИНЫ (не молодого), ОКРУЖЕННОЕ ВОРОТНИКОМ<br/>
        МАКИНО, БУЛЬКАЕТ, КРИЧИТ, ПОГРУЖАЕТСЯ В ВОДУ.
      </p>
      <p>НАЗАД В САРАЙ: МОЛОДОЙ воет, животное в клетке!</p>
      <p>ОН ОТБРАСЫВАЕТ ВЫРЕЗАННУЮ РУСАЛКУ...</p>
      <p>ОНА <u>РАЗБИВАЕТСЯ</u> НА ДВЕ ЧАСТИ!</p>
      <p>Желание быстро превращается в стыд.</p>
      <p>Сигнал фогорна. Воет ветер. Дождь льет в сарай.</p>
      <p>
        МОЛОДОЙ смотрит на сломанную РУСАЛКУ и сворачивается в клубок<br/>
        на мокрой земле, со спущенными до бедер штанами...
      </p>
      <p>Кажется, он вот-вот заплачет...</p>
      <p>
        Но он смеется. Он смеется, как будто с него упал огромный<br/>
        груз.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я сделал тебя. Ублюдок. Ты не можешь<br/>
        добраться до меня. Я схвачу тебя за горло!
      </p>
      <p>
        Он подползает к сломанной вырезанной русалке и начинает яростно колоть ее<br/>
        ОБЕДЕННЫМ НОЖОМ!
      </p>
      <p>
        КАРТИНКА: МОЛОДОЙ тянет веревку вниз по камням... ОН<br/>
        ПОДНИМАЕТ ЛОВУШКУ ДЛЯ ОМАРОВ...
      </p>
      <p style={{ textAlign: "right" }}>67.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page66" />
        <ForwardLink href="/page68" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710632895/the-lighthouse-script/x1kqgfravx5ks0veniu6.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page68;
